export enum OldDeviceStatus {
  ALL = "all",
  WITH_PHONE = "WithPhone",
  LOST_PHONE = "LostPhone",
}
